import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Col, Row } from 'antd'
import { useWatch } from 'react-hook-form'

import FormItem from 'components/Form/Item'
import Input from 'components/Form/Input'

import { formatErrorMessage } from 'helpers/contactRequestForm'
import { EMAIL_PATTERN, trimRequired } from 'helpers/validations'

const ContactFields = (props) => {
  const {
    intl,
    eventCategories,
    initialData,
    asSingleCol,
    autoFocusName,
  } = props

  const selectedEventCategoryId = useWatch({ name: 'eventCategoryId', defaultValue: initialData.eventCategoryId })
  const isB2B = !!eventCategories.find(category => !category.isB2c && category.id === selectedEventCategoryId)

  return (
    <>
      <Row gutter={24}>
        <Col md={asSingleCol ? 24 : 12}>
          <FormItem
            name="name"
            className="contact-request-form--contact-details__contact-field"
            label={`${intl.formatMessage({ id: 'contactRequestForm.name' })}*`}
          >
            <Input
              name="name"
              autoFocus={autoFocusName}
              defaultValue={initialData.name}
              rules={{ required: formatErrorMessage(intl, 'name') }}
            />
          </FormItem>
        </Col>

        <Col md={asSingleCol ? 24 : 12}>
          <FormItem
            name="company"
            className="contact-request-form--contact-details__contact-field"
            label={`${intl.formatMessage({ id: 'contactRequestForm.company' })}${isB2B ? '*' : ''}`}
          >
            <Input
              name="company"
              defaultValue={initialData.company}
              rules={{
                validate: trimRequired(formatErrorMessage(intl, 'company'), isB2B),
              }}
            />
          </FormItem>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col md={asSingleCol ? 24 : 12}>
          <FormItem
            name="email"
            className="contact-request-form--contact-details__contact-field"
            label={`${intl.formatMessage({ id: 'contactRequestForm.email' })}*`}
            >
            <Input
              name="email"
              type="email"
              defaultValue={initialData.email}
              rules={{
                required: formatErrorMessage(intl, 'email'),
                pattern: {
                  value: EMAIL_PATTERN,
                  message: formatErrorMessage(intl, 'email', 'invalid'),
                },
              }}
            />
          </FormItem>
        </Col>

        <Col md={asSingleCol ? 24 : 12}>
          <FormItem
            name="phone"
            className="contact-request-form--contact-details__contact-field"
            label={`${intl.formatMessage({ id: 'contactRequestForm.phone' })}*`}
            >
            <Input
              name="phone"
              type="tel"
              defaultValue={initialData.phone}
              rules={{
                required: intl.formatMessage({ id: 'contactRequestForm.errors.phone' }),
                pattern: {
                  value: /^[^a-zA-Z]*$/,
                  message: intl.formatMessage({ id: 'errors.invalid' }),
                },
              }}
            />
          </FormItem>
        </Col>
      </Row>
    </>
  )
}

ContactFields.propTypes = {
  intl: PropTypes.object.isRequired,
  initialData: PropTypes.shape({
    name: PropTypes.string,
    company: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    eventCategoryId: PropTypes.any,
  }),
  eventCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
  asSingleCol: PropTypes.bool,
  autoFocusName: PropTypes.bool,
}

ContactFields.defaultProps = {
  initialData: {},
  autoFocusName: true,
}

export default injectIntl(ContactFields)
